import getConfig from 'next/config';

export const isStaging = (): boolean => {
  const { publicRuntimeConfig } = getConfig();
  const memriseEnv = publicRuntimeConfig.MEMRISE_ENV;
  return memriseEnv === 'testing';
};
